import { Link, useLocation, useHistory } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { registerFetcher } from "../../api/requests";
import { useToaster } from "../../context/toaster";

function SignupConfirmation() {
  const [codeDigits, setCodeDigits] = useState(["", "", "", "", "", ""]);
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);
  const [canResend, setCanResend] = useState(true);

  const location = useLocation();
  const history = useHistory();
  const { addMessage } = useToaster();
  const logo2 = process.env.PUBLIC_URL + "/img/vaghfnama-logo.png";
  const username = location.state?.username;

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type,
      text,
    });
  };

  const handleDigitChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;
    const updatedDigits = [...codeDigits];
    updatedDigits[index] = value;
    setCodeDigits(updatedDigits);
    setCode(updatedDigits.join(""));

    if (value && index < 5) {
      const nextInput = document.getElementById(`code-digit-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleRegistrationConfirmation = async () => {
    setLoading(true);
    try {
      const response = await registerFetcher.postCode({ code, username });

      if (
        response.detail === "احراز هویت با موفقیت انجام شد. کاربر تأیید گردید."
      ) {
        showToast("success", "اعتبارسنجی با موفقیت انجام شد.");
        history.push("/auth/login");
      } else {
        showToast("error", "کد وارد شده صحیح نمی‌باشد.");
      }
    } catch {
      showToast("error", "کد وارد شده صحیح نمی‌باشد.");
    } finally {
      setLoading(false);
      setCode("");
      setCodeDigits(["", "", "", "", "", ""]);
    }
  };

  const getCode = useCallback(async () => {
    if (!username) return;
    try {
      await registerFetcher.getCode({ username });
      showToast("success", "کد تأیید ارسال شد.");
      setRemainingTime(120);
      setCanResend(false);
    } catch (err) {
      console.error(err);
      showToast("error", "ارسال کد با خطا مواجه شد.");
    }
  }, [username]);

  useEffect(() => {
    if (!remainingTime) return;
    const timer = setInterval(() => {
      setRemainingTime((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [remainingTime]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" + s : s}`;
  };

  return (
    <>
      <Col md={5} className="p-5 bg-white full-height">
        <div className="login-main-left">
          <div className="text-center mb-5 login-main-left-header pt-4">
            <a href="/">
              <img src={logo2} width="40%" className="img-fluid" alt="LOGO" />
            </a>
            <p>لطفا کد ارسال شده به شماره موبایل خود را وارد کنید.</p>
          </div>

          {/* دریافت کد button */}
          <div className="text-center mb-4">
            <Button variant="primary" disabled={!canResend} onClick={getCode}>
              {canResend
                ? "دریافت کد"
                : `ارسال مجدد تا ${formatTime(remainingTime)}`}
            </Button>
          </div>

          <Form
            className="text-right"
            onSubmit={(e) => {
              e.preventDefault();
              handleRegistrationConfirmation();
            }}
          >
            <Form.Group
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Form.Label>کد</Form.Label>
              <div
                className="d-flex"
                style={{
                  direction: "ltr",
                  gap: "2%",
                  width: "100%",
                  justifyContent: "end",
                }}
              >
                {codeDigits.map((digit, index) => (
                  <Form.Control
                    key={index}
                    id={`code-digit-${index}`}
                    type="text"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleDigitChange(e.target.value, index)}
                    style={{
                      width: "40px",
                      textAlign: "center",
                      fontSize: "18px",
                      padding: "6px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      flexGrow: "1",
                    }}
                    onKeyDown={(e) => {
                      if (
                        e.key === "Backspace" &&
                        !codeDigits[index] &&
                        index > 0
                      ) {
                        const prevInput = document.getElementById(
                          `code-digit-${index - 1}`
                        );
                        prevInput?.focus();
                      }
                    }}
                  />
                ))}
              </div>
            </Form.Group>

            <div className="mt-4">
              <Row>
                <Col>
                  <Button
                    type="submit"
                    variant="outline-primary"
                    size="lg"
                    block
                    disabled={loading}
                    style={{ cursor: loading ? "wait" : "pointer" }}
                  >
                    {loading ? "لطفا منتظر بمانید..." : "ارسال"}
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>

          <div className="text-center mt-5">
            <p className="light-gray">
              حساب کاربری دارید؟ <Link to="/auth/login">ورود</Link>
            </p>
          </div>
        </div>
      </Col>
    </>
  );
}

export default SignupConfirmation;
